module.exports = dormakaba.vendorReact['vendor/react'];